import { useAppRouter } from '@/common/route/useAppRouter';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_GAME } from '@/modules/game/router';
import { useLocale } from '@/modules/locale/model/locale';
import { gameService } from '@/services/game';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useGameVariantTranslate() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const { localeSupportedOptions, getListSupported } = useLocale();

    const model = reactive({
        variantId: route.params.id as string,
        locale: null,
        hasData: false,
        title: ''
    });

    const beforeFetch = async () => {
        await getListSupported();
        if (!localeSupportedOptions.value.length) {
            router.push({ name: ROUTE_NAME_GAME.VARIANT.INDEX });
            return;
        }
    };

    const fetch = crudAction.executeAction({
        canExecute: () => model.locale != null,
        request: () => gameService.variant.getText(model.variantId, model.locale),
        onSuccess: ({ data }) => {
            model.hasData = true;
            model.title = data.title;
        },
        onError: () => {
            model.hasData = false;
            model.title = '';
        }
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            request: () => gameService.variant.updateText(model.variantId, model.locale, model.title),
            onSuccess: fetch
        }),
        remove: crudAction.confirmAndRemove({
            request: () => gameService.variant.removeText(model.variantId, model.locale),
            onSuccess: fetch
        })
    };

    return { model, localeSupportedOptions, beforeFetch, fetch, actions };
}
